import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setProducts,
  setCopyAll,
  removeSize,
  updateSizeField,
} from "../../../../redux/slices/productSlice";

const SizeTable = ({ activeIndex }) => {
  const dispatch = useDispatch();

  const formatSizes = (sizes) => {
    if (!sizes) return {};

    if (Array.isArray(sizes)) {
      return Object.fromEntries(
        sizes.filter((item) => item?.size).map((item) => [item.size, item]),
      );
    }

    if (typeof sizes === "object") {
      return sizes;
    }

    return {};
  };
  const { products, copyAll, appliedSizes } = useSelector(
    (state) => state.product,
  );

  const currentProduct = products?.[activeIndex];

  // =========================
  // UPDATE SIZE FIELD (SAFE IMMUTABLE)
  // =========================
  const updateSizeFieldHandler = (size, field, value) => {
    dispatch(
      updateSizeField({
        index: activeIndex,
        size,
        field,
        value,
      }),
    );
  };

  // =========================
  // REMOVE SIZE
  // =========================
  const removeSizeHandler = (size) => {
    dispatch(
      removeSize({
        index: activeIndex,
        size,
      }),
    );
  };

  return (
    <div className="mt-5">
      {/* COPY TO ALL */}
      <label className="flex items-center gap-2 text-sm text-gray-700 mb-3">
        <input
          type="checkbox"
          checked={copyAll}
          onChange={(e) => dispatch(setCopyAll(e.target.checked))}
          className="h-4 w-4"
        />
        Copy price details to all sizes
      </label>

      <h3 className="font-semibold text-gray-800 mb-3 text-base">
        Size Matrix
      </h3>

      {/* TABLE */}
      <div className="border rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">
            <thead>
              <tr className="bg-gray-100 text-sm">
                <th className="px-3 py-3 text-left">Size</th>
                <th>Price</th>
                <th>MRP</th>
                <th>Inventory</th>
                <th>SKU</th>
                <th>Bust</th>
                <th>Shoulder</th>
                <th>Waist</th>
                <th>Length</th>
                <th>Hip</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentProduct?.selectedSizes?.map((size) => {
                const sizeObj = currentProduct?.sizes?.find((s) => {
                  return s.size === size;
                });

                return (
                  <tr key={size} className="border-t">
                    <td className="px-3 py-3 font-medium text-indigo-600">
                      {size}
                    </td>

                    {[
                      "price",
                      "mrp",
                      "inventory",
                      "sku",
                      "bust",
                      "shoulder",
                      "waist",
                      "length",
                      "hip",
                    ].map((field) => (
                      <td key={field} className="px-2 py-2">
                        <input
                          type="text"
                          inputMode="numeric"
                          value={sizeObj?.[field] || ""}
                          onChange={(e) =>
                            updateSizeFieldHandler(size, field, e.target.value)
                          }
                          className="h-9 w-[90px] border rounded px-2 text-xs"
                        />
                      </td>
                    ))}

                    <td className="px-3 py-2">
                      <button
                        onClick={() => removeSizeHandler(size)}
                        className="text-red-600 text-xs bg-red-50 px-2 py-1 rounded"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SizeTable;
